import { atom } from 'jotai';

export const videoRefreshInProgressAtom = atom(false);
videoRefreshInProgressAtom.debugLabel = 'videoRefreshInProgress';

export default { videoRefreshInProgressAtom };
